/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Table_StatusInputs */



/**
* | output |
* | --- |
* | "Status" |
*
* @param {Work_Order_Publish_Table_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_table_status = /** @type {((inputs?: Work_Order_Publish_Table_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Table_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Statut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Status")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Статус")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("地位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("状態")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Status")
	return /** @type {LocalizedString} */ ("Status")
});